<section class="position-relative" [hidden]="!(!video.isActive)">
	<section [ngClass]="styles.inactiveVideo">
		<span class="glyphicons ban"></span>
		{{ 'Media_Videos_Playback_VideoIsInactive' | translate }}
	</section>
</section>

<section [ngClass]="styles.wrapper">

	<section *ngIf="videoHasEmbedAccessEnabled" layout="row">
		<label id="panelVideoShare" [ngClass]="styles.label">
			{{ 'Media_Videos_Sharing_Label' | translate }}
		</label>
		<div [ngClass]="styles.radioBtnGroup" vbUiRadioBtnGroup aria-labelledby="panelVideoShare">
			<button type="button" [(ngModel)]="currentShareView" vbUiRadioBtn="Link">
				{{ 'Link' | translate }}
			</button>
			<button type="button" [(ngModel)]="currentShareView" vbUiRadioBtn="Embed">
				{{ 'Media_Videos_Sharing_Embed' | translate }}
			</button>
		</div>
	</section>

	<section layout="row">
		<vb-ui-share-link *ngIf="currentShareView === 'Link'" [ngClass]="styles.shareView" [enableSpark]="sparkEnabled" [playbackPosition]="playbackPosition" [video]="video">
		</vb-ui-share-link>
		<vb-ui-share-embed *ngIf="currentShareView === 'Embed'" [ngClass]="styles.shareView" [defaultAutoplay]="mediaFeatures.autoplayDefault" [playbackPosition]="playbackPosition" [video]="video" [playbackConfig]="playbackConfig">
		</vb-ui-share-embed>
		<div [ngClass]="styles.passwordInfo">
			{{ (videoHasPublicAccess ? 'Media_Videos_Embed_PublicVideo' : 'Media_Videos_Embed_AccessWarning') | translate }}
		</div>
	</section>

</section>
